const Events = require('PSEvents');
const PSUI = require('PSUIControl');
const OperatorEvents = require('PSOperatorEvents');
const GameUI = require('GameUI');
const GenericUI = require('GenericUI');

cc.Class({
    extends: cc.Component,

    properties: {
        PSUIPrefab: cc.Prefab,
    },

    onLoad () {
        const PSUINode = cc.instantiate(this.PSUIPrefab);
        PSUINode.parent = this.node;

        GenericUI.set(PSUI);
        // initialize global button for handling menu outside touch
        this.button = PSUINode.getComponent(cc.Button);
        this.button.enabled = false;
        this.node.zIndex = 20;

        // this is the main node for CUI and needs to be persistent
        cc.game.addPersistRootNode(this.node);

        OperatorEvents.init();

        // initialiez PSUI module
        const GUI = PSUINode.getChildByName('GameUI').getComponent(GameUI);

        PSUI.init(GUI); // passing GameUI node and controller to PSUI API
        GUI.node.active = true;

        Events.subscribe(Events.MENU_OPENED, () => {
            this.button.enabled = true;
        });

        Events.subscribe(Events.MENU_CLOSED, () => {
            this.button.enabled = false;
        });

        cc.find('Canvas').active = true;
    },

    /**
     * TEST function to triggered by test button for internal checks e.g reality check
     */
    test () {
        // reality check test
        // Events.publish(Events.REALITY_CHECK, {
        //     duration: 2000,
        //     sumBetAmount: 14567,
        //     sumWinAmount: 151613,
        //     gamingBalanceChangeAmount: 555
        // });

        // CommonUI.open('infoPopup', {
        //     title: 'close-game',
        //     message: 'loss-limit-popup',
        //     // closeEnabled: true,
        //     buttons: [
        //         {
        //             title: 'on',
        //             handler: () => {
        //                 console.log('-------------------------------------------');
        //                 console.log('-------------------TEST--------------------');
        //                 console.log('-------------------------------------------');
        //             }
        //         },
        //         {
        //             title: 'off',
        //             handler: () => {
        //                 console.log('-------------------------------------------');
        //                 console.log('-------------------TEST--------------------');
        //                 console.log('-------------------------------------------');
        //             }
        //         }
        //     ]
        // });
    },

    onViewResized () {
        if (cc.director.isPaused() && !this.timeoutFlag) {
            this.timeoutFlag = true;
            setTimeout(() => {// to update widgets in scene when the director is paused
                this.timeoutFlag = false;
                cc.director.emit(cc.Director.EVENT_AFTER_UPDATE);
            }, 1);
        }
    },
});
